import React, { Component } from "react";

import { SoftCheck } from "../common/SoftCheck";
import * as styles from "./RowDate.scss";

export interface IRowCheckProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
}

export class RowCheck extends Component<IRowCheckProps> {
    public render() {
        const { checked, onChange } = this.props;
        return (
            <span className={styles["row-date"]}>
                <SoftCheck
                    checked={checked}
                    onToggle={onChange}
                    asActionButton={true}
                />
            </span>
        );
    }
}
